import Introduction from '../../containers/introduction/introduction'
import Skills from '../../containers/skills/skills'
import Projects from '../../containers/projects/projects'
import Contact from '../../containers/contact/contact'

const Home = () => {
  return (
    <main>
      <Introduction />
      <Skills />
      <Projects />
      <Contact />
    </main>
  )
}

export default Home
